import type { IPostContentData, IPostContentDataDealStory } from '~/types/community';
import { has } from '~/components/utils/core/object';

export function isPostContentADealStory(content: IPostContentData): content is IPostContentDataDealStory {
  return has(content, 'deal');
}
